/*
 * @license
 * Copyright© Celligence LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import Spinner from "react-bootstrap/Spinner";
import "./index.css";

const LoadingSpinner = ({ 
  message = "Loading...",
  size = "md",
  variant = "border" 
}) => {
  return (
    <div 
      className="text-center loader-container" 
      role="status" 
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner 
        animation={variant}
        size={size === "sm" ? "sm" : undefined}
        aria-hidden="true"
      />
      <span className="visually-hidden">{message}</span>
      <p className="loading-text" aria-hidden="true">
        {message}
      </p>
    </div>
  );
};

export default React.memo(LoadingSpinner);
